import { HTTPClient, propsToDate, propsToDatePaged } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { DateHelper } from '@abaco/web-components/src/components/DateUtils';
import axios, { CancelTokenSource } from "axios";
import { Document, DocumentType, DocumentCategory, DocumentOut, DocumentCategoryCheck } from '../models/Document';
export default class DocumentApi {

    private http: HTTPClient;
    private rootPath: string;
    private cancelTokenSource: CancelTokenSource | null;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
        this.cancelTokenSource = null;
    }

    public async getDocumentCategories(pkCuaa: number, campaign: number, itemId: number): Promise<DocumentCategory[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pkCuaa}/${campaign}/actions/${itemId}/dictionary_document_categories`, {
            params: {
                offset: 0,
                count: 300,
            }
        });
        return res.data.records;
    }
    public async getDocumentTypes(pkCuaa: number, campaign: number, itemId: number): Promise<DocumentType[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pkCuaa}/${campaign}/actions/${itemId}/dictionary_document_types`, {
            params: {
                offset: 0,
                count: 300,
            }
        });
        return res.data.records;
    }
    public async getDocuments(pkCuaa: number, campaign: number, itemId: number): Promise<Document[]> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pkCuaa}/${campaign}/actions/${itemId}/documents`, {
            params: {
                offset: 0,
                count: 300,
            }
        });
        return res.data.records;
    }



    public async deleteDocument(pkCuaa: number, campaign: number, itemId: number, documentId: number): Promise<Document> {
        const res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pkCuaa}/${campaign}/actions/${itemId}/documents/${documentId}`);
        return res.data;
    }
    public async insertDocument(pkCuaa: number, campaign: number, itemId: number, detailOut: DocumentOut): Promise<Document> {
        const res = await this.http.post(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pkCuaa}/${campaign}/actions/${itemId}/documents`, detailOut);
        return res.data;
    }

    public async getFilteredDocumentCategory(pk_cuaa: number, stock_item_id: number, act_type_id: number): Promise<any> {
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/stocks/${stock_item_id}/dictionary_document_categories?filter=act_type_id eq ${act_type_id}`);
        return res.data;
    }

    public async getStockDocumentCategory(pk_cuaa: number, stock_item_id: number): Promise<any> {
            const res = await this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/stocks/${stock_item_id}/dictionary_document_categories`);
            return res.data.records;
    }

    public async getStockDocumentTypes(pk_cuaa: number, stock_item_id: number, act_type_id: number): Promise<any> {
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/stocks/${stock_item_id}/dictionary_document_types?filter=act_type_id eq ${act_type_id}`);
        return res.data.records;
    }

    public async getStockDocuments(pk_cuaa: number, stock_item_id: number): Promise<any> {
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/stocks/${stock_item_id}/documents`);
        return res.data.records;
    }

    public async deleteStockDocument(pkCuaa: number, stock_item_id: number, documentId: number): Promise<Document> {
        const res = await this.http.delete(`${this.rootPath}/v1/warehouse/subjects/${pkCuaa}/stocks/${stock_item_id}/documents/${documentId}`);
        return res.data;
    }

    public async insertStockDocument(pkCuaa: number, stock_item_id: number, detailOut: DocumentOut): Promise<Document> {
        const res = await this.http.post(`${this.rootPath}/v1/warehouse/subjects/${pkCuaa}/stocks/${stock_item_id}/documents`, detailOut);
        return res.data;
    }

    public async insertProductPrice(pkCuaa: number, stocked_lot_id: number, detailOfPrice: any): Promise<any> {
        const res = await this.http.post(`${this.rootPath}/v1/ref_prices/entity_types/STOCK/subjects/${pkCuaa}/ref_prices/${stocked_lot_id}`, detailOfPrice);
        return res.data;
    }

    public async getProductPrice(pkCuaa: number, stocked_lot_id: number, refDate: number): Promise<any> {
        const res = await this.http.get(`${this.rootPath}/v1/ref_prices/entity_types/STOCK/subjects/${pkCuaa}/ref_prices/${stocked_lot_id}?ref_date=${refDate}`);
        return res.data;
    }

}
